import withType from 'components/common/hoc/withType'
import BreadcrumbTwoColumns from './BreadcrumbTwoColumns'

export default withType({
  type: [
    'BOTBreadcrumbTwoColumnsLink',
    'BOTTireCompareBreadcrumbTwoColumnsLink',
    'BOTQuoteBreadcrumbTwoColumnsLink'
  ],
  placeholders: ['links', 'right']
})(BreadcrumbTwoColumns)
